import DateService from "../../Services/Shared/Date.service";
export default class AppointmentCampaignInfoDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { startDate: json.startDate && new Date(json.startDate), endDate: json.endDate && new Date(json.endDate) });
    }
    static getInfoTextFields(info) {
        const fields = [];
        if (info.staffPeople.length) {
            fields.push({
                label: "Staff",
                value: info.staffPeople.map(({ fullName }) => fullName).join(", "),
            });
        }
        if (info.serviceOfferings.length) {
            fields.push({
                label: "Service Offerings",
                value: info.serviceOfferings.map(({ name }) => name).join(", "),
            });
        }
        if (info.locations.length) {
            fields.push({
                label: "Campuses",
                value: info.locations.map(({ name }) => name).join(", "),
            });
        }
        if (info.meetingTypes.length) {
            fields.push({
                label: "Meeting Types",
                value: info.meetingTypes.map(({ name }) => name).join(", "),
            });
        }
        if (info.startDate || info.endDate) {
            fields.push({
                label: "Dates",
                value: `${info.startDate ? DateService.display(info.startDate) : ""} - ${info.endDate ? DateService.display(info.endDate) : ""}`,
            });
        }
        if (info.overrideTaskTitle) {
            fields.push({
                label: "Task  Title",
                value: info.overrideTaskTitle,
            });
        }
        if (info.overrideTaskDescription) {
            fields.push({
                label: "Task Description",
                value: info.overrideTaskDescription,
            });
        }
        return fields;
    }
    static getInfoTextFieldsForMeetingScheduler(info) {
        const fields = [];
        if (info.staffPeople.length) {
            fields.push({
                label: "Staff",
                value: info.staffPeople.map(({ fullName }) => fullName).join(", "),
            });
        }
        if (info.serviceOfferings.length) {
            fields.push({
                label: "Service Offerings",
                value: info.serviceOfferings.map(({ name }) => name).join(", "),
            });
        }
        if (info.locations.length) {
            fields.push({
                label: "Campuses",
                value: info.locations.map(({ name }) => name).join(", "),
            });
        }
        if (info.meetingTypes.length) {
            fields.push({
                label: "Meeting Types",
                value: info.meetingTypes.map(({ name }) => name).join(", "),
            });
        }
        if (info.startDate || info.endDate) {
            fields.push({
                label: "Dates",
                value: `${info.startDate ? DateService.display(info.startDate) : ""} - ${info.endDate ? DateService.display(info.endDate) : ""}`,
            });
        }
        return fields;
    }
    static getInfoTextFieldsForMeetingSchedulerAppointmentCampaign(info) {
        const fields = [];
        if (info.serviceOfferings.length) {
            fields.push({
                label: "Services",
                value: info.serviceOfferings.map(({ name }) => name).join(", "),
            });
        }
        if (info.locations.length) {
            fields.push({
                label: "Campuses",
                value: info.locations.map(({ name }) => name).join(", "),
            });
        }
        if (info.staffPeople.length) {
            fields.push({
                label: "Staff",
                value: info.staffPeople.map(({ fullName }) => fullName).join(", "),
            });
        }
        if (info.startDate || info.endDate) {
            fields.push({
                label: "Dates",
                value: `${info.startDate ? DateService.display(info.startDate) : ""} - ${info.endDate ? DateService.display(info.endDate) : ""}`,
            });
        }
        return fields;
    }
}
